export const bodyScrollLock = (isOpen: boolean) => {
  if (!document) return;

  if (isOpen) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = '';
  }
};

export const lockBodyScroll = () => {
  if (!document) return;
  document.body.style.overflow = 'hidden';
  document.body.style.position = 'fixed';
  document.body.style.width = '100%';
};

export const unlockBodyScroll = () => {
  if (!document) return;
  document.body.style.overflow = '';
  document.body.style.position = '';
  document.body.style.width = '';
};

export const lockBodyScrollClass = (className: string = 'body-lock') => {
  document?.body.classList.add(className);
};

export const unlockBodyScrollClass = (className: string = 'body-lock') => {
  document?.body.classList.remove(className);
};

export const scrollTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};